export default __webpack_public_path__ + "static/media/pc-img-team-business-553-px@2x.7527830f.png";